import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-add-linea',
  templateUrl: './add-linea.component.html',
  styleUrls: ['./add-linea.component.scss']
})
export class AddLineaComponent implements OnInit {
  lineaForm: FormGroup;

  constructor(public dialoRef: MatDialogRef<AddLineaComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder) {
    this.initForm();
  }

  ngOnInit(): void {
  }
  initForm(): void {
    this.lineaForm = new FormGroup({
      observacion: new FormControl('', Validators.required)
    });
  }
}
